import {
  AdfDateFnsAdapter,
  CardViewDateItemComponent,
  ClipboardService,
  MOMENT_DATE_FORMATS,
  TranslationService,
  UserPreferencesService,
} from '@alfresco/adf-core';
import {
  Component,
  Inject,
  LOCALE_ID,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import {
  DatetimeAdapter,
  MAT_DATETIME_FORMATS,
} from '@mat-datetimepicker/core';
import { MatDatetimepickerType } from '@mat-datetimepicker/core/datetimepicker/datetimepicker-type';
import {
  MomentDatetimeAdapter,
  MAT_MOMENT_DATETIME_FORMATS,
} from '@mat-datetimepicker/moment';
import { parse } from 'date-fns';

@Component({
  selector: 'wk-card-view-date-item',
  templateUrl: './wk-card-view-date-item.component.html',
  styleUrls: ['./wk-card-view-date-item.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: AdfDateFnsAdapter },
    { provide: MAT_DATE_FORMATS, useValue: MOMENT_DATE_FORMATS },
    { provide: DatetimeAdapter, useClass: MomentDatetimeAdapter },
    { provide: MAT_DATETIME_FORMATS, useValue: MAT_MOMENT_DATETIME_FORMATS },
  ],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class WkCardViewDateItemComponent
  extends CardViewDateItemComponent
  implements OnInit
{
  dateTypeSelector: MatDatetimepickerType;
  datePickerInterval = 5;

  constructor(
    dateAdapter: DateAdapter<Date>,
    userPreferencesService: UserPreferencesService,
    clipboardService: ClipboardService,
    translateService: TranslationService,
    @Inject(LOCALE_ID) private readonly locale: string
  ) {
    super(
      dateAdapter,
      userPreferencesService,
      clipboardService,
      translateService
    );
  }

  public ngOnInit(): void {
    this.dateTypeSelector = this.property.type as MatDatetimepickerType;
    this.property.locale = this.locale;

    (this['dateAdapter'] as AdfDateFnsAdapter).displayFormat = 'L LT';

    if (this.property.value) {
      const stringdisplayValue = Array.isArray(this.property.displayValue)
        ? this.property.displayValue[0]
        : this.property.displayValue;
      this.valueDate = parse(stringdisplayValue, 'Pp', new Date());
    }
  }
}
